<div class="property-listing-container mt-3 p-3">
  <div class="page-title d-flex justify-content-between align-items-center mb-3">
    <h4>Property Listings</h4>
    <!-- <p-button pButton type="button" label="Create Property" icon="pi pi-plus" class="p-0"
      (click)="showDialog('right')"></p-button> -->
  </div>

  <p-table [value]="properties" responsiveLayout="scroll" [paginator]="true" [rows]="20"
    [rowsPerPageOptions]="[10,20,50]" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} properties">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Property Address</th>
        <th>Property Domain</th>
        <th>Property Timezone</th>
        <th>Textbot Phone#</th>
        <th>Yardi Property Name</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-property>
      <tr>
        <td>{{ property.name }}</td>
        <td>{{ property.address }}</td>
        <td>{{ property.domain }}</td>
        <td>{{ property.timezone }}</td>
        <td>{{ property.phone }}</td>
        <td>{{ property.yardi_property_name || '-' }}</td>
        <td>
          <div class="d-flex align-items-center gap-2">
             <p-button pButton class="icon-secondary-btn p-mr-2" icon="pi pi-pencil"
              (click)="showDialogForEdit('right', property)">
            </p-button>
            <!-- <p-button pButton class="icon-primary-btn" icon="pi pi-trash" (click)="confirmDelete(property)">
            </p-button> -->
            <!-- this button will be use to impersonate to landlord portal from super admin portal -->
            <!-- (click)="impersonateToLandlordPortal(property)" -->
            <p-button pButton class="icon-primary-btn" icon="pi pi-sign-in" tooltip="Impersonate to Landlord Portal"
              tooltipPosition="top" (click)="impersonateToLandlordPortal(property)">
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog header="Create Property" [modal]="true" [(visible)]="visible" [position]="position" [style]="{ width: '35%' }" draggable="false">
  <app-create-property></app-create-property>
</p-dialog>

<!-- Create/Update Property -->
<p-dialog *ngIf="visible" [header]="selectedProperty ? 'Update Property' : 'Create Property'" [modal]="true"
  [(visible)]="visible" [position]="position" [style]="{ width: '35%' }" draggable="false">
  <app-create-property *ngIf="visible" [buttonLabel]="selectedProperty ? 'Update' : 'Create'"
    [property]="selectedProperty" (closeDialog)="onDialogClose()"></app-create-property>
</p-dialog>
<!-- Confirm Cancel Dialog -->
<p-dialog header="Confirm Cancel" [(visible)]="showCancelDialog" modal="true" [closable]="false" [responsive]="true"
  [style]="{width: '350px'}">
  <div class="confirmation-content">
    <p>Are you sure you want to cancel? All unsaved changes will be lost.</p>
  </div>
  <div class="d-flex justify-content-end gap-2 mt-3">
    <p-button label="No" (click)="declineCancel()"></p-button>
    <p-button label="Yes" class="p-button-danger" (click)="confirmCancel()"></p-button>
  </div>
</p-dialog>

<!-- Confirm Delete Dialog -->
<p-dialog header="Confirm Delete" [(visible)]="showDeleteDialog" modal="true" [closable]="false" [responsive]="true"
  [style]="{width: '350px'}">
  <div class="confirmation-content">
    <p>Are you sure you want to delete this property?</p>
  </div>
  <div class="d-flex justify-content-end gap-2 mt-3">
    <p-button label="No" (click)="declineCancel()"></p-button>
    <p-button label="Yes" class="p-button-danger" (click)="confirmCancel()"></p-button>
  </div>
</p-dialog>